/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Morepricedrops2Inputs */

const he_home_morepricedrops2 = /** @type {(inputs: Home_Morepricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עוד ירידות מחירים`)
};

const en_home_morepricedrops2 = /** @type {(inputs: Home_Morepricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More price drops`)
};

/**
* | output |
* | --- |
* | "More price drops" |
*
* @param {Home_Morepricedrops2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const home_morepricedrops2 = /** @type {((inputs?: Home_Morepricedrops2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Morepricedrops2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_morepricedrops2(inputs)
	return en_home_morepricedrops2(inputs)
});
export { home_morepricedrops2 as "home_morePriceDrops" }